import { defineStore } from "pinia";
import { ref } from "vue";
import Api from "@/model/api.js";

export const useGlobalStore = defineStore("global", () => {
  const isWebToMpRedirectEnable = ref(false);

  const fetchWebToMpRedirectEnable = async () => {
    try {
      isWebToMpRedirectEnable.value = await Api.fetchIsWebToMpRedirectEnable();
    } catch (error) {
      console.error(error);
    }
  };

  return { isWebToMpRedirectEnable, fetchWebToMpRedirectEnable };
});
